export type {
  VideoComponentDefinition,
  VideoPlayerProps,
} from './Video.interfaces';
export {isLabeledLanguageCode} from './Video.utils';
export {VideoComponent} from './VideoComponent';
export {ComponentDefinition} from './VideoDefinition';
export type {SchemaType} from './VideoDefinition';
export {VideoPreviewComponent} from './VideoPreviewComponent';
export {PlayerUI} from './ui';

import {Registry} from '@backstage-components/base';
import {ComponentDefinition} from './VideoDefinition';
import {VideoModule} from './VideoModule';
Registry.register(ComponentDefinition, VideoModule);
